import { getAppUrlInfo } from '../helpers'

export default function useAppName() {
  const { appName } = getAppUrlInfo()

  return appName
}
